import styled from "styled-components";
import { srOnlyStyle } from "../../../../shared-components/toyota/styles/utils/Accessibility.styles";
import { breakpoints, maxBreakpoints } from "../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.nav`
    display: flex;
    position: sticky;
    top: var(--visibleHeaderHeight, 0);
    margin-inline: calc(var(--spacing-3) * -1);
    padding-inline: var(--spacing-3);
    padding-block: var(--spacing-2);
    background-color: var(--color-grey-1);
    z-index: var(--z-index-sticky);

    @media screen and (min-width: ${breakpoints.xxl}) {
        margin-inline: calc(var(--spacing-7) * -1);
        padding-inline: var(--spacing-7);
    }

    @supports not (margin-block: 0) {
        top: 0;
        margin-left: calc(var(--spacing-7) * -1);
        margin-right: calc(var(--spacing-7) * -1);
        padding: var(--spacing-2) var(--spacing-7);
    }
`;

export const Title = styled.span`
    ${srOnlyStyle};
`;

export const List = styled.ol`
    display: flex;
    column-gap: var(--spacing-1);
    padding-inline-start: 0;
    list-style: none;

    li {
        display: flex;
        align-items: center;
        column-gap: var(--spacing-1);

        @media screen and (max-width: ${maxBreakpoints.sm}) {
            &:not(:nth-last-child(1)):not(:nth-last-child(2)) {
                display: none;
            }
        }
    }

    @supports not (padding-inline: 0) {
        padding-left: 0;

        & > li:not(:nth-last-child(1)) {
            margin-right: var(--spacing-1);

            & > *:nth-child(1) {
                margin-right: var(--spacing-1);
            }
        }
    }
`;

export const Link = styled.a`
    margin-block: 0;
    font-family: var(--font-regular);
    font-size: 1.3rem;
    line-height: 2rem;
    text-transform: none;
    color: var(--color-primary-black);

    &[aria-current="location"] {
        font-family: var(--font-book);
    }
`;

export const Separator = styled.span`
    display: flex;
    align-items: center;
    width: 20px;
    height: 20px;
`;
